import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'

import { environment } from '@env'
import { thirdPartyApplications } from './valid-application-guard.constants'

export const validApplicationGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const thirdPartyApplicationNames = thirdPartyApplications
    .filter((app) => !!app.domain)
    .map((app) => app.domain.split('/').reverse()[0])
  const router = inject(Router)

  const { application } = route.params
  if (
    state.url !== environment.NOT_PERMITTED_URL &&
    !thirdPartyApplicationNames.includes(application?.trim())
  ) {
    return router.navigate([environment.NOT_PERMITTED_URL])
  }
  return true
}

